export default "__VITE_ASSET__f628d7c9__"